import { VideoDetail, IVideoChatMsg, IVideoHistoryChatMsg } from "../model/video";
import { getData, postData } from "../utils/HttpUtils";

export async function getVideoDetail(video_id: string): Promise<VideoDetail> {
  return getData("/api/solve/video_detail", { video_id });
}

export async function videoChat(query: string, video_id: string): Promise<IVideoChatMsg> {
  return postData("/api/solve/video_chat", { query, video_id });
}

export async function getChatHistory(video_id: string, ref_id?: string): Promise<{
  ref_id: string
  history_list: IVideoHistoryChatMsg[]
}> {
  return getData('/api/solve/video_chat_history', ref_id ? {video_id, ref_id} : {video_id})
}